//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import F447P0 from "../../Az/Shortcode/Content/F447P0";

//Element
class N2C359 extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB cH8711 x3x96w" },
            //Element
            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB n26x0w" },
                //Element
                React.createElement(Row, {},
                    //Element
                    React.createElement(Col, { md: 8 },
                        //Element
                        React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB h424y6" },
                            //Element
                            React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB e3332b" },
                                //Element
                                React.createElement("em", {},
                                    //Element
                                    "Təhlükəsiz Tikililər "
                                ),
                                //Element
                                React.createElement("br", {}),
                                //Element
                                "Sağlam Xətlərlə Başlayır."
                            )
                        )
                    ),
                    //Element
                    React.createElement(Col, { md: 4 },
                        //Element
                        React.createElement("div", { className: "S0u16d C96Q4r fE0d48 vR05U6 W44s9p pEO064 a527eB h424y6" },
                            //Element
                            React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x502ng" },
                                //Element
                                "Davamlı və Etibarlı Enerji Xidmətləri ilə Hər",
                                //Element
                                React.createElement("br", {}),
                                //Element
                                "Toxunuş Gələcəyə Dəyər Qatar."
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB cH8711 uf00x3" },
                //Element
                React.createElement(F447P0, {})
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default N2C359;